module.exports = __webpack_public_path__ + "img/Egypt.d9aac818.svg";